<template>
    <Footer1 v-if="props.version == 1" :columnsize="props.columnsize">
        <slot></slot>
    </Footer1>
    <Footer2 v-if="props.version == 2" :columnsize="props.columnsize" :isdark="props.isdark"
        :columnlist="props.columnlist" :logo="logo" :socialmedia="socialmedia" />
</template>

<script setup>
import { defineProps } from 'vue';
import Footer1 from './FooterVersion/PandoraFooter1.vue';
import Footer2 from './FooterVersion/PandoraFooter2.vue';

const props = defineProps({
    columnsize: {
        type: Number,
        default: 4
    },
    version: {
        type: Number,
        default: 1
    },
    isdark: {
        type: Boolean,
        default: true
    },
    logo: {
        type: Boolean,
        default: false
    },
    socialmedia: {
        type: Boolean,
        default: false
    },
    columnlist: {
        default: []
    },
});
</script>
<style>
.pandora-footer a {
    color: #BBB;
    text-decoration: none;
    font-family: sans-serif;
    font-weight: bold;
    font-size: 13px;
}

.pandora-footer a:hover {
    color: #FFF;
}

.pandoraContainer {
    max-width: 1150px;
    margin: auto;

    justify-items: center;
    display: grid;
    grid-template-rows: 1fr;
}

.pandora-footer-switch {
    display: none;
}

.pandora-footer {
    background-color: #333;
    position: relative;
    min-height: 23vh;
    margin-top: -20px;
    z-index: 0;
    align-content: center;
}

.pandora-footer ul {
    width: 930px;
    /* display: flex; */
    flex-wrap: wrap;
    z-index: 10;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    padding-inline-start: 0;
}
</style>